export const ACTION_SSO_LOGOUT = 'sso/LOGOUT';
export const ACTION_SSO_TRIGGER_LOGIN = 'sso/LOGIN';

export function ssoLogout() {
  return (dispatch) => {
    dispatch({ type: ACTION_SSO_LOGOUT });
  };
}

export function triggerSsoLogin() {
  return (dispatch) => {
    dispatch({ type: ACTION_SSO_TRIGGER_LOGIN });
  };
}
